import React from 'react';

/**
 * Hexagon Pattern Background — a repeating hexagonal grid rendered as a
 * tiled SVG data-URL. Uses tone-on-tone colors that match the navy site
 * background, so text stays fully readable at every intensity preset.
 */

const PRESETS = {
  subtle: { opacity: 0.05, strokeAlpha: 0.5, sizePx: 44 },
  medium: { opacity: 0.09, strokeAlpha: 0.7, sizePx: 40 },
  bold:   { opacity: 0.14, strokeAlpha: 0.9, sizePx: 36 },
};

const HexagonBackground = ({ intensity = 'subtle' }) => {
  const p = PRESETS[intensity] || PRESETS.subtle;
  const stroke = `rgba(148, 163, 184, ${p.strokeAlpha})`;
  const svg = encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 52' width='60' height='52'>
      <polygon points='30,2 58,17 58,45 30,60 2,45 2,17' fill='none' stroke='${stroke}' stroke-width='1'/>
    </svg>`
  );
  return (
    <div
      className="fixed inset-0 pointer-events-none -z-10"
      aria-hidden="true"
      data-testid="hex-pattern-bg"
      style={{
        backgroundImage: `url("data:image/svg+xml;utf8,${svg}")`,
        backgroundSize: `${p.sizePx}px ${Math.round(p.sizePx * 0.867)}px`,
        opacity: p.opacity,
      }}
    />
  );
};

export default HexagonBackground;
